import { GridColDef } from "@mui/x-data-grid-pro"
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { BtnAddOnTableRender, BtnEditOnTableRender, DefaultParamCol } from "../Ticket/components/CreateColumnTable";
import { useEffect, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid';
import { I18NextNs } from "enum/enum";
import { useForm } from "react-hook-form";
import { numberFormatterLocale } from "../Ticket/fnTickit";
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";

export function useAccountingPaymentList() {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [nPrmUser, setNPrmUser] = useState(0);
    const [lstStatus, setLstStatus] = useState([]);
    const [lstOptionMuseum, setLstOptionMuseum] = useState([]);
    const [userType, setUserType] = useState(0)
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sDateCreate",
        sSortDirection: "desc",
    });


    //#region Form
    const formSearch = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    // #endregion

    useEffect(() => {
        GetMenuPermissionParamRoute("/AccountingPaymentList", AxiosFn, setIsPermission, DialogFn);
    }, []);


    useEffect(() => {
        getStatusById();
        getCheckEmpMuseum();
        getTable(dataRow);
    }, [])

    const getCheckEmpMuseum = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setNPrmUser(objResult.nPrmUser)
            setUserType(objResult.nUserTypeID)
            setLstOptionMuseum(objResult.lstMuseum)
        });
    };

    const getStatusById = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetStatusById`, { sMode: "P", sStatusId: "0,1,2,3" }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setLstStatus(objResult.lstStatus)
        });
    };

    const getTable = (p: PaginationInterface) => {
        DialogFn.BlockUI();
        setLoadingTable(true);
        let Param = {
            ...p,
            arrRows: [],
            sType: "payment",
            nStartDate: formSearch.getValues("nStartDate") ? formSearch.getValues("nStartDate").valueOf() : null,
            nEndDate: formSearch.getValues("nEndDate") ? formSearch.getValues("nEndDate").valueOf() : null,
            arrStatusId: formSearch.getValues("arrStatusId") ?? [],
            arrMuseumId: formSearch.getValues("arrMuseum") ?? [],
        };
        AxiosFn.Post(`PaymentTicket/GetTablePaymentTicket`, Param, (result) => {
            DialogFn.UnBlockUI();
            setLoadingTable(false);
            let objResult = result.objResult;
            setDataRow({
                ...p,
                arrRows: objResult.lstData,
                nDataLength: objResult.nDataLength,
                nPageIndex: objResult.nPageIndex,
            });
        });
    };
    const onDelete = (arrSelect) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            setLoadingTable(true);
            AxiosFn.Post(`PaymentTicket/OnDeleteTablePayment`, { lstId: arrSelect }, () => {
                getTable(dataRow)
                DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent));
                DialogFn.UnBlockUI();
            });
        });
    }

    const handleClearSearch = () => {
        Object.keys(formSearch.getValues()).forEach((key => {
            formSearch.setValue(key, null);
            formSearch.clearErrors(key);
        }))
        getTable(dataRow);
    };


    const dataColumn: GridColDef[] = [
        {
            ...DefaultParamCol,
            field: "cAction",
            width: 60,
            minWidth: 60,
            headerName: "",
            type: "actions",
            flex: 0,
            sortable: false,
            renderHeader: () => {
                if (isPermission && nPrmUser === 2) {
                    return (
                        <BtnAddOnTableRender
                            path={"/AccountingPaymentForm"}
                            nPermision={nPrmUser}
                        />
                    );
                }
            },
            renderCell: (params) => {
                return (
                    <BtnEditOnTableRender
                        path={"/AccountingPaymentForm"}
                        params={params}
                        nPermision={isPermission ? params.row.isView ? 1 : 2 : 1}
                    />
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sDatePayment",
            headerName: `วันที่นำฝาก`,
        },
        {
            ...DefaultParamCol,
            field: "sMuseum",
            headerName: `${I18n.SetText("Ticket.MuseumName")}`,
            align: "left",
            flex: 3,

        },
        {
            ...DefaultParamCol,
            field: "nTotalTicket",
            headerName: `จำหน่ายตั๋ว`,
            align: "right",
            flex: 1.2,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nTotalETicket",
            headerName: `จำหน่ายตั๋ว E-Ticket`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nTotalRent",
            headerName: `ค่าเช่า`,
            align: "right",
            flex: 1.2,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nTotalDonate",
            headerName: `เงินบริจาค`,
            align: "right",
            flex: 1.2,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nTotal",
            headerName: `ยอดรวม`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sNamePayment",
            headerName: `${I18n.SetText("Ticket.NameSaver")}`,
            align: "left",
            flex: 2,
        },
        {
            ...DefaultParamCol,
            field: "sDateCreate",
            headerName: `${I18n.SetText("Ticket.DateSave")}`,
        },
        {
            ...DefaultParamCol,
            field: "sStatus",
            headerName: `${I18n.SetText("Ticket.Status")}`,
            flex: 2,
        },
    ];

    return {
        formSearch,
        dataColumn,
        getTable,
        onDelete,
        handleClearSearch,
        dataRow,
        loadingTable,
        lstStatus,
        lstOptionMuseum,
        userType,
        nPrmUser
    };
}

